module.exports = __webpack_public_path__ + "static/media/testing_software_and_mocking_services_with_loopback.11680eaa.md";